// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep div #quote-component-div-id {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 0;
  margin: 0;
  border-radius: 1rem;
  overflow: hidden;
  background: white !important;
  box-shadow: var(--shadow-2);
}
::ng-deep div #quote-component-div-id .quote-progress-bar {
  position: relative;
  min-height: 6px;
  width: 100%;
}
::ng-deep p-panel.quote-block-ui {
  border: none;
  margin: 0;
  padding: 0;
}
::ng-deep p-panel.quote-block-ui .p-panel-header {
  display: none;
}
::ng-deep p-panel.quote-block-ui .p-panel-content {
  background: transparent !important;
  border: none !important;
  padding: 0;
  margin: 0;
}
::ng-deep p-panel.quote-block-ui .quick-quote-header {
  font-family: "Times New Roman", Hoefler Text, Liberation Serif, Times, Cambria, serif;
  background: linear-gradient(90deg, #004d00, #008000);
  color: white;
  padding: 1rem 1rem 6rem 1rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
::ng-deep p-panel.quote-block-ui .quick-quote-content {
  background: white;
  margin-top: -6rem;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
::ng-deep .text-align-center {
  text-align: center;
}
::ng-deep .flex-justify-center {
  justify-content: center;
  align-items: center;
}
::ng-deep .flex-align-center {
  align-items: center;
}
::ng-deep div.quote-table-relative {
  position: relative;
}
::ng-deep table.quote-table {
  margin-bottom: 1.25rem;
  width: 100% !important;
}
::ng-deep table.quote-table td {
  padding: 0.5rem 0;
  font-size: 0.85em;
}
::ng-deep table.quote-table td:first-child {
  padding: 0.5rem 0 0 0.5rem;
}
::ng-deep div.quote-table-relative div.quote-table-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
}
::ng-deep div.quote-table-relative div.quote-table-overlay .p-button.p-button-icon-only {
  padding: 0.5rem 0.67rem;
  border-radius: 0.25rem;
  opacity: 0.9;
}
::ng-deep form.ng-form input.ng-invalid:not(.ng-untouched) {
  border: 1px solid red !important;
}
::ng-deep form.ng-form p-dropdown.ng-invalid.ng-touched .p-dropdown {
  border: 1px solid red !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/quote/quote.component.scss"],"names":[],"mappings":"AACC;EACC,kBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,2BAAA;AAAF;AAEE;EACC,kBAAA;EACA,eAAA;EACA,WAAA;AAAH;AAKE;EACC,YAAA;EACA,SAAA;EACA,UAAA;AAHH;AAKG;EACC,aAAA;AAHJ;AAMG;EACC,kCAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;AAJJ;AAOG;EACC,qFAAA;EACA,oDAAA;EACA,YAAA;EACA,4BAAA;EACA,yCAAA;AALJ;AAQG;EACC,iBAAA;EACA,iBAAA;EACA,8BAAA;EACA,+BAAA;AANJ;AAWC;EACC,kBAAA;AATF;AAYC;EACC,uBAAA;EACA,mBAAA;AAVF;AAaC;EACC,mBAAA;AAXF;AAcC;EAA2B,kBAAA;AAX5B;AAYC;EACC,sBAAA;EACA,sBAAA;AAVF;AAYE;EACC,iBAAA;EACA,iBAAA;AAVH;AAYG;EACC,0BAAA;AAVJ;AAgBE;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;AAdH;AAgBG;EACC,uBAAA;EACA,sBAAA;EACA,YAAA;AAdJ;AAqBG;EACC,gCAAA;AAnBJ;AA0BI;EACC,gCAAA;AAxBL","sourcesContent":["::ng-deep {\n\tdiv #quote-component-div-id {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tflex: 1;\n\t\tflex-direction: column;\n\t\tflex-wrap: nowrap;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tborder-radius: 1rem;\n\t\toverflow: hidden;\n\t\tbackground: white !important;\n\t\tbox-shadow: var(--shadow-2);\n\n\t\t.quote-progress-bar {\n\t\t\tposition: relative;\n\t\t\tmin-height: 6px;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\tp-panel {\n\t\t&.quote-block-ui {\n\t\t\tborder: none;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\n\t\t\t.p-panel-header {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\n\t\t\t.p-panel-content {\n\t\t\t\tbackground: transparent !important;\n\t\t\t\tborder: none !important;\n\t\t\t\tpadding: 0;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t.quick-quote-header {\n\t\t\t\tfont-family: \"Times New Roman\", Hoefler Text, Liberation Serif, Times, Cambria, serif;\n\t\t\t\tbackground: linear-gradient(90deg, #004d00, #008000);\n\t\t\t\tcolor: white;\n\t\t\t\tpadding: 1rem 1rem 6rem 1rem;\n\t\t\t\tbox-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n\t\t\t}\n\n\t\t\t.quick-quote-content {\n\t\t\t\tbackground: white;\n\t\t\t\tmargin-top: -6rem;\n\t\t\t\tborder-top-left-radius: .5rem;\n\t\t\t\tborder-top-right-radius: .5rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t.text-align-center {\n\t\ttext-align: center;\n\t}\n\n\t.flex-justify-center {\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t.flex-align-center {\n\t\talign-items: center;\n\t}\n\n\tdiv.quote-table-relative { position: relative; }\n\ttable.quote-table {\n\t\tmargin-bottom: 1.25rem;\n\t\twidth: 100% !important;\n\n\t\ttd {\n\t\t\tpadding: .5rem 0;\n\t\t\tfont-size: .85em;\n\n\t\t\t&:first-child {\n\t\t\t\tpadding: .5rem 0 0 .5rem;\n\t\t\t}\n\t\t}\n\t}\n\n\tdiv.quote-table-relative {\n\t\tdiv.quote-table-overlay {\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tbackground-color: rgba(255, 255, 255, 0.6);\n\t\t\tdisplay: flex;\n\t\t\tflex-wrap: nowrap;\n\t\t\tjustify-content: flex-end;\n\t\t\talign-items: center;\n\n\t\t\t.p-button.p-button-icon-only {\n\t\t\t\tpadding: .5rem .67rem;\n\t\t\t\tborder-radius: .25rem;\n\t\t\t\topacity: .9;\n\t\t\t}\n\t\t}\n\t}\n\n\tform.ng-form {\n\t\tinput {\n\t\t\t&.ng-invalid:not(.ng-untouched) {\n\t\t\t\tborder: 1px solid red !important;\n\t\t\t}\n\t\t}\n\n\t\tp-dropdown {\n\t\t\t&.ng-invalid.ng-touched {\n\n\t\t\t\t.p-dropdown {\n\t\t\t\t\tborder: 1px solid red !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
